module.exports = __webpack_public_path__ + "static/img/floor1.a93e7047.png";